import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW0901Component } from './kymw0901.component';
import { GetChangeItemListService } from './api-services/get-change-item-list.service';
import { RenewPlanGoodsChangeService } from './api-services/renew-plan-goods-change-manage.service';
import { SaveChangeFixationService } from './api-services/save-change-fixation.service';



/**
 * 変更確認画面 モジュール設定クラス
 *
 * @export KYMW0901Module
 * @class KYMW0901Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0901Component,
  ],
  providers: [
    GetChangeItemListService,
    RenewPlanGoodsChangeService,
    SaveChangeFixationService,
  ],
})
export class KYMW0901Module {
}
